import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import Select, { OnChangeValue } from 'react-select'
import '../v2/DropdownForm/index.scss'
import clsx from 'clsx'
import FieldErrorSectionForm from '@App/kit/fields/FieldErrorSectionForm'
import { DropdownFormFieldProps } from '@App/forms/common/dropdown-form-field'
import { determineChangeValue } from '@App/common/utils'
import { SelectOption } from '@Components/Selectors/Select'

const DropdownForm = (props: DropdownFormFieldProps) => {
    const { control } = useFormContext()
    const {
        name,
        options,
        mainColor = true,
        label,
        assistiveText,
        placeholder,
        className,
        assistiveTextFunction,
        showLabelOnSelect = true,
        registerOptions,
        isPhoneType = false,
        defaultValue,
        assistiveTextVisibility,
        isClearable,
    } = props

    const required = !!registerOptions && !!registerOptions.required
    const displayAssistiveText = assistiveText ?? (assistiveTextFunction ? assistiveTextFunction(required) : undefined)
    const theDefaultValue = defaultValue ? defaultValue : ''

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={theDefaultValue}
            rules={registerOptions}
            render={({ field: { value, onChange, onBlur, ref }, fieldState }) => {
                const outerDivClassNames = clsx(
                    'dropdown-form-component',
                    mainColor ? 'main-color-set' : 'second-color-set',
                    className,
                    !!fieldState.error && 'error',
                    isPhoneType && 'phone-code-form-type',
                    !!label && !!placeholder && 'dropdown-padded-placeholder'
                )

                // Show the label if there is a value, or placeholder text, and it's not explicitly disabled.
                const shouldShowLabel = (!!value || !!placeholder) && !!label && showLabelOnSelect

                return (
                    <>
                        <div className={outerDivClassNames}>
                            {shouldShowLabel && (
                                <label className="dropdown-form-label" htmlFor={name}>
                                    {label}
                                </label>
                            )}
                            <div className="select-form-component">
                                <Select
                                    inputId={name}
                                    name={name}
                                    key={`select-${name}-${value}`}
                                    ref={ref}
                                    options={options}
                                    placeholder={placeholder ? placeholder : label}
                                    value={options.find((opt) => opt.value === '' + value)}
                                    onBlur={onBlur}
                                    onChange={(newValue: OnChangeValue<SelectOption, false>) =>
                                        onChange(determineChangeValue(newValue))
                                    }
                                    classNamePrefix="react-select"
                                    isClearable={!!isClearable}
                                />
                            </div>
                            <FieldErrorSectionForm
                                name={name}
                                assistiveText={displayAssistiveText}
                                visibility={assistiveTextVisibility}
                                required={required}
                            />
                        </div>
                    </>
                )
            }}
        />
    )
}

export default DropdownForm
